define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "react-toastify", "react-toastify/dist/ReactToastify.css"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _reactToastify, _ReactToastify) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ToasterContainer = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var _excluded = ["className", "bodyClassName", "progressClassName"];

  var ReactToastAdapter = function ReactToastAdapter(_ref) {
    var className = _ref.className,
        bodyClassName = _ref.bodyClassName,
        progressClassName = _ref.progressClassName,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    return /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, (0, _extends2.default)({
      className: className,
      bodyClassName: bodyClassName,
      progressClassName: progressClassName
    }, props));
  };

  var ToasterContainer = (0, _styledComponents.default)(ReactToastAdapter).attrs({
    className: 'teste',
    bodyClassName: 'vg-body',
    progressClassName: 'progress'
  }).withConfig({
    displayName: "ToasterContainer",
    componentId: "sc-1towc50-0"
  })(["margin:0;padding:0;&.Toastify__toast-container{width:360px;}.Toastify__close-button{display:none;}.Toastify__toast{background-color:", ";border-radius:5px;box-shadow:0 1px 1px 1px rgba(0,0,0,0.3);cursor:auto;margin:0;padding:0;}.vg-body{margin:0;}.progress{visibility:hidden;}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.white;
  });
  _exports.ToasterContainer = ToasterContainer;
});